import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  iconClass: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 44,
    height: 44,
    marginRight: theme.spacing(1),
    borderRadius: "50%",
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundImage: ({ image }) => image && `url(${image})`,
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: theme.palette.primary.main,
    background: "white"
  },
  iconClassActive: {
    color: theme.palette.jamii.yellow,
    background: theme.palette.jamii.mildBlue,
    boxShadow: theme.shadows[6]
  }
}));
